import { render, staticRenderFns } from "./SubRooomListItem.vue?vue&type=template&id=72828858&scoped=true"
import script from "./SubRooomListItem.vue?vue&type=script&lang=ts"
export * from "./SubRooomListItem.vue?vue&type=script&lang=ts"
import style0 from "./SubRooomListItem.vue?vue&type=style&index=0&id=72828858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72828858",
  null
  
)

export default component.exports